import { useContext } from 'react';

import { SnackbarContext } from './utils';

export const useSnackbar = () => {
  const { closeSnackbar, showErrorSnackbar, showSnackbar } = useContext(SnackbarContext)!;

  return { closeSnackbar, showErrorSnackbar, showSnackbar };
};
